/* eslint-disable camelcase */
export default {
  table: 'стол',
  empty_slot: 'Пусто',
  loading: 'Загрузка...',
  no_tables: 'Нет доступных столов',
  view_network: 'Просмотр вашей текущей сети',
  navigate_hint: 'Здесь вы можете перемещаться по вашим открытым сетям',
};
